import React, { forwardRef } from 'react';
import Tooltip from '../Tooltip/Tooltip.js';
const IconButton = forwardRef(function IconButton({ children, tooltip, tooltipPlacement = 'bottom-end', ...props }, ref) {
    return (React.createElement(Tooltip, { tooltip: tooltip || props['aria-label'], placement: tooltipPlacement, delay: 500 },
        React.createElement("button", { ref: ref, ...props }, children)));
});
export default IconButton;
//# sourceMappingURL=IconButton.js.map